import { toast } from 'react-toastify';

// Dedupe key for the generic API error toast. Using a fixed toastId means
// rapid repeated clicks on a save/submit button that keeps failing won't
// stack identical toasts — each new error replaces the previous one.
const API_ERROR_TOAST_ID = 'api-error';

export const handleApiCall = async <T>(
  apiFunc: () => Promise<T>,
  successMsg: string,
  onSuccess?: (res: T) => void,
  onError?: (err: any) => void
) => {
  try {
    const response = await apiFunc();
    // if (successMsg) toast.success(successMsg);
    if (onSuccess) onSuccess(response);
    return response;
  } catch (error: any) {
    if (onError) onError(error);
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      toast.error(error.response.data.message, {
        toastId: API_ERROR_TOAST_ID
      });
      return; // Don't rethrow if already handled
    } else {
      toast.error(error.message || 'An error occurred.', {
        toastId: API_ERROR_TOAST_ID
      });
    }
    throw error; // Let interceptor handle toast/errors
  }
};
